import React from 'react';
import S from './styles';
import dummy from '../../resources/icon.jpg';

import ru from '../../resources/b_ru.jpeg';
import clint from '../../resources/b_clint.jpeg';
import ever from '../../resources/b_ever.jpeg';
import ts from '../../resources/b_ts.png';
import tt from '../../resources/b_tt.jpeg';

import { SupporterItem } from "../supporter-item"

const supporterList = [
  {
    name: 'Rubin',
    company: 'Estsoft',
    profile: ru,
    email: 'dbqlsdl1234@naver.com',
    git: 'https://github.com/Dev-RubinJo',
    summary: '코드로 여행을 떠나는 여행가',
  },
  {
    name: '태태',
    company: '프렌클리',
    profile: tt,
    email: 'taetae.dev@gmail.com',
    git: 'https://github.com/uuu1101',
    summary: '개발하는 클라이머',
  },
  {
    name: '에버(Ever)',
    company: '카카오뱅크',
    profile: ever,
    email: 'qudrms007@naver.com',
    git: 'https://github.com/sh4ck3rs/resume',
    instagram: 'https://instagram.com/ever_1015?igshid=YmMyMTA2M2Y=',
    summary: '삽질 좋아하는 은행원입니다.',
  },
  {
    name: '태승',
    company: '아파트너',
    profile: ts,
    email: 'ryan.son1002@gmail.com',
    git: 'https://github.com/ryan-son',
    blog: 'https://velog.io/@ryan-son',
    summary: '합리적인 해결책 찾기를 좋아합니다.',
  },
  {
    name: '클린트',
    company: '트러스테이',
    profile: clint,
    email: 'jang.wangsu@gmail.com',
    git: 'https://github.com/ClintJang',
    blog: 'https://medium.com/@jang.wangsu',
    summary: '수다하는 것을 즐기는 개발자',
  },
]

export const Supporters = () => (
  <S.Section>
    <S.Title
      id='supporters'
      data-sal="slide-up"
      data-sal-delay="100"
      data-sal-duration="600"
      data-sal-easing="ease"
    >
      Supporters
    </S.Title>
    <S.Wrap>
      { supporterList.map((supporter, index) => (<SupporterItem supporter={supporter} index={index} key={supporter.name} />))}
    </S.Wrap>

  </S.Section>
)
